import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";
import { RepState } from "./types";
import {User} from '@/models/user_schema';

const state: RepState = {
  rep: [] as User[],
  selected: {} as User
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
